import {toggleScrollHeight} from "../toggle/toggleScrollHeight.js";
export const btnMoreFunc = (e, item) => {
    item.closest('.bet-content').classList.remove('shadow');
    item.closest('.wrap-more').querySelector('.show-more-block').classList.add('active');
    // debugger;
    let hidden = item.closest('.toggle-hidden');
    item.remove();
    // toggleScrollHeight([hidden], '.bet-content');
    if (hidden) setTimeout(() => toggleScrollHeight([hidden], '.bet-content'), 10);
};